module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "border-card",
      "value": "activeChannels"
    },
    on: {
      "tab-click": _vm.onChangeTab
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Active Channels",
      "name": "activeChannels"
    }
  }, [_c('channel-list', {
    attrs: {
      "channels": _vm.channels,
      "active": _vm.activeChannelTab === 'activeChannels'
    },
    on: {
      "deactivateChannel": _vm.deactivateChannel
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Inactive Channels",
      "name": "inactiveChannels"
    }
  }, [_c('channel-list', {
    attrs: {
      "channels": _vm.channels,
      "active": _vm.activeChannelTab === 'activeChannels'
    },
    on: {
      "activateChannel": _vm.activateChannel
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-579cf79e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/channel/Channels.vue
// module id = 3290
// module chunks = 3